export const makeOpt = (x)=>({
        kind: "some",
        value: x
    });
export const emptyOpt = ()=>({
        kind: "none"
    });
